import reasonApi from '@/api/reason.js'
import { handleApiError } from '@/api/util'
export default {
  methods: {
    async getReasonByName({ pageId, reasonName }) {
      try {
        const response = await reasonApi.getReasonList({
          params: {
            page_id: pageId,
            limit: 1,
            offset: 0,
            reason: reasonName
          }
        })
        if (response.status == 200) {
          return response.data.data || []
        }
      } catch (error) {
        await handleApiError(error)
      }
    },
    async handleSaveReason({ pageId, currentReason }) {
      const reasonSameName = await this.getReasonByName({
        pageId,
        reasonName: currentReason.reason
      })
      if (reasonSameName.length > 0 && reasonSameName[0].id !== currentReason.id) {
        await this.$swal.fire({
          title: 'Please use another reason',
          type: 'error',
          confirmButtonText: this.$t('Confirm')
        })
        return false
      }
      try {
        const response = await reasonApi.postReason({
          data: {
            page_id: pageId,
            reason: currentReason.reason,
            reason_route: this.convertReasonRoute(currentReason.reason_route)
          }
        })
        if (response.status == 200 || response.status == 204) {
          return true
        }
      } catch (error) {
        await handleApiError(error)
        return false
      }
    },
    convertReasonRoute(reasonRoute) {
      return reasonRoute.map((route) => {
        return {
          level_1: { ...this.convertSubReasonRoute(route.subReason), title: route.title }
        }
      })
    },
    convertSubReasonRoute(subReasonRoute) {
      if (!subReasonRoute || subReasonRoute.length == 0) return {}
      const level = subReasonRoute[0].level

      return {
        [`level_${level}`]: subReasonRoute.map((route) => {
          return {
            title: route.title,
            ...this.convertSubReasonRoute(route.subReason)
          }
        }, [])
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/view/template/ticket/Reason/ReasonMixin.js